import { ReactElement, useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { MD_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import HomeStack from '~/ui/pages/Home/common/HomeStack';
import { cart } from '~/constants/siteConfig';
import CommonSwiper from '~/ui/pages/Home/common/CommonSwiper/CommonSwiper';

const FragranceSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$fragranceSection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$fragranceSection',
  });
  const fragranceRef = useRef(null);
  const { ymalName3 } = cart;
  const windowSize = useWindowSize();
  const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;

  return (
    <section className="hp-section fragrance-section" id="hp-fragrance">
      <div className="fragrance-section-container">
        <div className="mobile-only">
          <HomeStack
            title={t('heading')}
            description={t('description')}
            img="/images/homePage/fragranceSection/pullman-bed.webp"
            imgMobile="/images/homePage/fragranceSection/pullman-bed-mob.webp"
            url={tLink('fragrance-section')}
            loading="eager"
          />
        </div>
        <CommonSwiper
          ymalName={ymalName3}
          isHomepageList
          ref={fragranceRef}
          spaceBetween={20}
          breakpoints={{
            960: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
          }}
        />
      </div>
    </section>
  );
};

export default FragranceSection;
